import { render, staticRenderFns } from "./ServiceMonitoring.vue?vue&type=template&id=bbec089c"
import script from "./ServiceMonitoring.vue?vue&type=script&lang=js"
export * from "./ServiceMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports